import { FormControl, FormInputProps, IColumn } from "dolfo2"
import { GameType, IBaseID, ITournamentType } from "pkm-special-tool"

export type SingleControl = FormControl & {
    readonly render: () => {
        readonly component: React.ComponentType<unknown & FormInputProps>
        readonly props?: any
        readonly col?: BsCol
    }
    readonly transform?: (value: any) => any
}

export type DetailType<T> = {
    [key in keyof Partial<T>]: SingleControl
}

export type IEntityList<T extends IBaseID> = Listable<T>

export interface Listable<T>{
    readonly list: T[]
}

export interface EColumn<T> extends IColumn<T>{
    readonly extract: (item: T) => React.ReactNode
}

export enum BsCol{
    _1 = "col-1",
    _2 = "col-2",
    _3 = "col-3",
    _4 = "col-4",
    _5 = "col-5",
    _6 = "col-6",
    _7 = "col-7",
    _8 = "col-8",
    _9 = "col-9",
    _10 = "col-10",
    _11 = "col-11",
    _12 = "col-12",
    AUTO = "col-auto",
    COL = "col"
}

export const getTeamListKey = (types: ITournamentType[], tournamentType: number) => {
    const type = types.find(t => t.id === tournamentType)
    return type?.gameType === GameType.TCG ? "DeckList" : "TeamList"
}